/*eslint-disable*/
import React, { use, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import loginPageStyle from "assets/jss/material-kit-pro-react/views/loginPageStyle.js";
import basicsStyle from "assets/jss/material-kit-pro-react/views/componentsSections/basicsStyle.js";
import image from "assets/img/bg7.jpg";
import {
	LoadingMgs,
	SuccessMessage,
	ErrorMessage,
} from "components/Common/toastify";
import { post } from "../../lib/requests";
import get from "../../lib/requests";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setUser } from "redux/ducks/userSlice";
const useStyles = makeStyles(loginPageStyle);
const useStyles3 = makeStyles(basicsStyle);

export default function SetQuestionPage() {
	const classes = useStyles();
	const classes3 = useStyles3();
	const [loading, setLoading] = useState(false);
	const userDetails = useSelector((state) => state.user);
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const [question1, setQuestion1] = useState("");
	const [question2, setQuestion2] = useState("");
	const [question3, setQuestion3] = useState("");
	const [answer1, setAnswer1] = useState("");
	const [answer2, setAnswer2] = useState("");
	const [answer3, setAnswer3] = useState("");
	const [securityQuestions, setSecurityQuestions] = useState([]);

	useEffect(() => {
		window.scrollTo(0, 0);
		document.body.scrollTop = 0;
		getSecurityQuestions();
		return function cleanup() {};
	}, []);

	const redirectLogin = (response) => {
		if (response.callnext == "login/mfa" || response.callnext == "login/pin") {
			navigate("/login-mfa");
			return;
		} else if (response.callnext == "qrcode/setquestion") {
			navigate("/login-set-question");
			return;
		} else if (response.callnext == "") {
			if (userDetails?.csp) {
				// navigate("/csp-dashboard");
				window.location.href = "/csp-dashboard";
			} else {
				navigate("/dashboard");
			}
			return;
		}
	};

	// form validation rules
	const validationSchema = Yup.object().shape({
		question1: Yup.string().required("Question 1 is required"),
		answer1: Yup.string().required("Answer 1 is required"),
		question2: Yup.string().required("Question 2 is required"),
		answer2: Yup.string().required("Answer 2 is required"),
		question3: Yup.string().required("Question 3 is required"),
		answer3: Yup.string().required("Answer 3 is required"),
	});
	const formOptions = { resolver: yupResolver(validationSchema) };

	// get functions to build form with useForm() hook
	const {
		register,
		handleSubmit,
		setError,
		setValue,
		reset,
		formState,
	} = useForm(formOptions);
	const { errors } = formState;

	async function onSubmit(formField) {
		setLoading(true);
		LoadingMgs("Set Question", "processing...");
		try {
			await post("/api/qrcode/setquestion", formField, true)
				.then((res) => {
					if (res.data.success) {
						SuccessMessage("Set Question", "Question set successfully");
						const callnext = res.data.records.callnext;
						dispatch(setUser({ callnext }));
						reset();
						if (callnext == "") {
							// navigate("/csp-dashboard");
							window.location.href = "/csp-dashboard";
						}
						reset();
					} else {
						console.log(res.data.errors, "res.data.errors");
						const message = res.data.errors.map((error) => {
							return error;
						});
						ErrorMessage("Set Question", message);
					}
					setLoading(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("Set Question", message);
					setLoading(false);
				});
		} catch (error) {
			console.log("error", error);
			ErrorMessage("Set Question", "Something went wrong try again!!");
			setLoading(false);
		}
	}

	const getSecurityQuestions = async () => {
		try {
			setLoading(true);
			await get("/api/qrcode/getquestion", true)
				.then((res) => {
					if (res.data.success) {
						setSecurityQuestions(res.data.records.questions);
					} else {
						ErrorMessage("QR Code", res.data.message);
					}
					setLoading(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("QR Code", message);
					setLoading(false);
				});
		} catch (error) {
			ErrorMessage("QR Code", "Something went wrong try again!!");
			setLoading(false);
		}
	};

	console.log(securityQuestions, "securityQuestions");

	useEffect(() => {
		if (securityQuestions.length > 0) {
			filterOutSelectedQuestion();
		}
	}, [question1, question2, question3]);

	const filterOutSelectedQuestion = () => {
		const questions = securityQuestions.filter(
			(item) => item !== question1 && item !== question2 && item !== question3
		);
		setSecurityQuestions(questions);
	};

	return (
		<div>
			<Header
				absolute
				color="info"
				brand="Auscomp Cloud Services"
				links={<HeaderLinks dropdownHoverColor="info" />}
			/>
			<div
				className={classes.pageHeader}
				style={{
					backgroundImage: "url(" + image + ")",
					backgroundSize: "cover",
					backgroundPosition: "top center",
				}}>
				<div className={classes.container}>
					<GridContainer justify="center">
						<GridItem xs={12} sm={12} md={6}>
							<Card>
								<form
									onSubmit={handleSubmit(onSubmit)}
									id="myForm"
									className={loading ? classNames("opacity-40", classes.form) : ""}>
									<CardHeader color="info" signup className={classes.cardHeader}>
										<h4 className={classes.cartLabel}>Set Question for MFA</h4>
									</CardHeader>
									<CardBody signup>
										<FormControl fullWidth className={classes3.selectFormControl}>
											<InputLabel htmlFor="simple-select" className={classes3.selectLabel}>
												Select Question 1
											</InputLabel>
											<Select
												MenuProps={{
													className: classes3.selectMenu,
												}}
												classes={{
													select: classes3.select,
												}}
												value={question1}
												onChange={(event) => {
													setQuestion1(event.target.value);
													setValue("question1", event.target.value);
												}}
												inputProps={{
													id: "question1",
													...register("question1"),
												}}>
												<MenuItem
													classes={{
														root: classes3.selectMenuItem,
														selected: classes3.selectMenuItemSelected,
													}}
													value={question1}>
													{question1}
												</MenuItem>
												{securityQuestions.map((item, index) => (
													<MenuItem
														key={index}
														classes={{
															root: classes3.selectMenuItem,
															selected: classes3.selectMenuItemSelected,
														}}
														value={item}>
														{item}
													</MenuItem>
												))}
											</Select>
										</FormControl>
										<div className="text-red-600 text-xs ml-3 pt-1">
											{errors.question1?.message}
										</div>
										<CustomInput
											formControlProps={{
												fullWidth: true,
											}}
											inputProps={{
												placeholder: "Answer 1...",
												type: "text",
												...register("answer1"),
											}}
										/>
										<div className="text-red-600 text-xs ml-3 pt-1">
											{errors.answer1?.message}
										</div>
										<FormControl fullWidth className={classes3.selectFormControl}>
											<InputLabel htmlFor="simple-select" className={classes3.selectLabel}>
												Select Question 2
											</InputLabel>
											<Select
												MenuProps={{
													className: classes3.selectMenu,
												}}
												classes={{
													select: classes3.select,
												}}
												value={question2}
												onChange={(event) => {
													setQuestion2(event.target.value);
													setValue("question2", event.target.value);
												}}
												inputProps={{
													id: "question2",
													...register("question2"),
												}}>
												<MenuItem
													classes={{
														root: classes3.selectMenuItem,
														selected: classes3.selectMenuItemSelected,
													}}
													value={question2}>
													{question2}
												</MenuItem>
												{securityQuestions.map((item, index) => (
													<MenuItem
														key={index}
														classes={{
															root: classes3.selectMenuItem,
															selected: classes3.selectMenuItemSelected,
														}}
														value={item}>
														{item}
													</MenuItem>
												))}
											</Select>
										</FormControl>
										<div className="text-red-600 text-xs ml-3 pt-1">
											{errors.question2?.message}
										</div>
										<CustomInput
											formControlProps={{
												fullWidth: true,
											}}
											inputProps={{
												placeholder: "Answer 2...",
												type: "text",
												...register("answer2"),
											}}
										/>
										<div className="text-red-600 text-xs ml-3 pt-1">
											{errors.answer2?.message}
										</div>
										<FormControl fullWidth className={classes3.selectFormControl}>
											<InputLabel htmlFor="simple-select" className={classes3.selectLabel}>
												Select Question 3
											</InputLabel>
											<Select
												MenuProps={{
													className: classes3.selectMenu,
												}}
												classes={{
													select: classes3.select,
												}}
												value={question3}
												onChange={(event) => {
													setQuestion3(event.target.value);
													setValue("question3", event.target.value);
												}}
												inputProps={{
													id: "question3",
													...register("question3"),
												}}>
												<MenuItem
													classes={{
														root: classes3.selectMenuItem,
														selected: classes3.selectMenuItemSelected,
													}}
													value={question3}>
													{question3}
												</MenuItem>

												{securityQuestions.map((item, index) => (
													<MenuItem
														key={index}
														classes={{
															root: classes3.selectMenuItem,
															selected: classes3.selectMenuItemSelected,
														}}
														value={item}>
														{item}
													</MenuItem>
												))}
											</Select>
										</FormControl>
										<div className="text-red-600 text-xs ml-3 pt-1">
											{errors.question3?.message}
										</div>
										<CustomInput
											formControlProps={{
												fullWidth: true,
											}}
											inputProps={{
												placeholder: "Answer 3...",
												type: "text",
												...register("answer3"),
											}}
										/>
										<div className="text-red-600 text-xs ml-3 pt-1">
											{errors.answer3?.message}
										</div>
									</CardBody>
									<div className={classes.textCenter}>
										<Button
											simple
											color="info"
											size="lg"
											type="submit"
											disabled={formState.isSubmitting}>
											Verify
										</Button>
									</div>
								</form>
							</Card>
						</GridItem>
					</GridContainer>
				</div>
			</div>
		</div>
	);
}
